import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useLocalize, useWindowWidth } from '@treams/treams-hooks';
import {
	EvaluationFormFragment,
	EvaluationSectionItem,
	useEvaluationFormQuery,
} from '@treams/treams-network';
import { Heading3, Title } from '@treams/treams-ui';

import {
	SelectConversationCardDescription as Description,
	SelectConversationTypeCardQuestion as Question,
	SelectConversationTypeCardSkeleton as Skeleton,
} from '.';

export const SelectConversationTypeCard = ({ id, description, title }: EvaluationFormFragment) => {
	const { localize } = useLocalize();

	const { t } = useTranslation('', {
		keyPrefix: 'evaluations.create.modal.form.selectConversationType.card',
	});

	const { data } = useEvaluationFormQuery({
		variables: { id },
	});

	const questions = data?.evaluationForm.sections.flatMap((section) => {
		return section.items.map((item: EvaluationSectionItem) => {
			return <Question key={item.id} {...item} />;
		});
	});

	const isMobile = useWindowWidth(640);

	const titleLabel = localize(title).text;

	return (
		<Box width="100%" p={isMobile ? 1 : 5} pt={4}>
			<Title pb={3}>{titleLabel} </Title>
			<Heading3 pb={1}>{t('description')}</Heading3>
			<Description description={description} />
			<Box pt={4} pb={3}>
				<Heading3> {t('preview')} </Heading3>
				{data ? <ul>{questions}</ul> : <Skeleton />}
			</Box>
		</Box>
	);
};
